import React from 'react';

import { Container } from '@mui/system';

interface ContainerLayoutProps {
  children: React.ReactNode;
}

const ContainerLayout: React.FC<ContainerLayoutProps> = ({ children }) => {
  return <Container sx={{ pb: 12 }}>{children}</Container>;
};

export default ContainerLayout;
